export default async function getCheckoutData(sessionId: string) {
  const firstPromise = await fetch(`/api/${sessionId}`)
  const secondPromise = await firstPromise.json()
  return {
    session: secondPromise.session,
    subscription: secondPromise.subscription
  }
}
